import React, { Component, Fragment } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import FooterGetApp from '../../components/FooterGetApp';
import SqzSubtext from '../../components/SqzSubtext';
import SqzText from '../../components/SqzText';
import WaveIcon from '../../components/WaveIcon';
import { analytics } from '../../utils/common';
import Homecards from './cards';

// eslint-disable-next-line react/prefer-stateless-function
class MeetSqueeze extends Component {
  componentDidMount() {
    analytics('Home');
  }
  render() {
    return (
      <Fragment>
        {/* <section className="home-join phone-only">
          <div className="container">
            <NavLink to="/appointment/locations">
              <button className="btn btn--larger homeBookButton">
                Book A Massage
              </button>
            </NavLink>
            <NavLink className="homeOtherTherapistLink" to="/therapist/list">
              BOOK A SPECIFIC THERAPIST
            </NavLink>
          </div>
        </section> */}

        <section className="meet-squeeze" id="Meetsqueeze">
          <div className="container">
            <div>
              <header className="meet-squeeze__hdr hide-phone">
                <WaveIcon>
                  <SqzText primary>Meet Squeeze</SqzText>
                </WaveIcon>
                <SqzSubtext>from the founders of Drybar</SqzSubtext>
              </header>
            </div>
            <div className="meetSqueezeHeader phone-only">
              <SqzText primary>Meet Squeeze</SqzText>
              <SqzSubtext>from the founders of Drybar</SqzSubtext>
            </div>

            <Homecards />
            <div>
              <footer>
                <div className="hdg-wave hide-phone">
                  <i className="icon icon--squiggle hdg-wave__icon" />
                  <span className="hdg-wave__text cursive-font">
                    <NavLink
                      aria-label="how-it-works"
                      className="btn btn--secondary home__btn homeScreenLearnMoreBtn"
                      aria-label="how-it-works-desktop-view"
                      to="/how-it-works"
                      onClick={() => {
                        analytics('Home - How it Works', null, true);
                      }}
                    >
                      Learn More
                    </NavLink>
                  </span>
                </div>
                <div className="hdg-wave mobileHowItWorksBtn phone-only">
                  <NavLink
                    aria-label="how-it-works"
                    className="btn btn--secondary home__btn"
                    aria-label="how-it-works-mobile-view"
                    to="/how-it-works"
                    onClick={() => {
                      analytics('Home - How it Works', null, true);
                    }}
                  >
                    See How It Works
                  </NavLink>
                </div>
              </footer>
            </div>
          </div>
        </section>

        <section className="home-join">
          <div className="container">
            <div className="subhdr-stripes subhdr-stripes--ucase hide-phone">
              <span className="stripes-bg" />
              JOIN THE FEEL-GOOD REVOLUTION
            </div>
            <div className="footerDiferDiv phone-only">
              <WaveIcon>
                <h1 className="footerDiferrence">
                  JOIN THE FEEL-GOOD REVOLUTION
                </h1>
              </WaveIcon>
            </div>
            <FooterGetApp />
            <div id="homeJoinPhonePoint" />
          </div>
        </section>
      </Fragment>
    );
  }
}

MeetSqueeze.propTypes = {};

export default compose(withRouter)(MeetSqueeze);
